import {
	UPDATE_SYSTEM_SOFTWARE_VERSIONS,
	SET_SYSTEM_SOFTWARE_VERSIONS,
	RESET_STATE,
	ADD_BATCH_LIST,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	ADD_BATCH_LIST_ITEM_ROW,
} from './systemSoftwareVersions.actions';

// utils
import _uniqueId from 'lodash/uniqueId';

const defaultState = {
	data: {
		systemSoftwareVersions: {},
		originalSystemSoftwareVersions: {},
		batchList: [
			{
				identifier: _uniqueId('row-'),
			},
		],
	},
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_SYSTEM_SOFTWARE_VERSIONS: {
			return {
				data: {
					...state.data,
					systemSoftwareVersions: payload,
					originalSystemSoftwareVersions: payload,
				},
			};
		}

		case UPDATE_SYSTEM_SOFTWARE_VERSIONS: {
			return {
				data: {
					...state.data,
					systemSoftwareVersions: {
						...state.data.systemSoftwareVersions,
						...payload,
					},
				},
			};
		}

		case RESET_STATE: {
			return {
				...defaultState,
			};
		}

		case ADD_BATCH_LIST: {
			return {
				...state,
				data: {
					...state.data,
					batchList: payload,
				},
			};
		}

		case EDIT_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.map((entry) => {
						if (entry.identifier === payload.identifier) {
							return { ...entry, ...payload };
						}
						return entry;
					}),
				},
			};
		}

		case REMOVE_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.filter(
						(entry) => entry.identifier !== payload
					),
				},
			};
		}

		case ADD_BATCH_LIST_ITEM_ROW: {
			return {
				...state,
				data: {
					...state.data,
					batchList: [
						...state.data.batchList,
						{
							...defaultState.data.batchList[0],
							identifier: _uniqueId('row-'),
						},
					],
				},
			};
		}

		default:
			return state;
	}
}

export default reducer;
